import { render, staticRenderFns } from "./ApprovalsTable.vue?vue&type=template&id=11b4a6fe&scoped=true"
import script from "./ApprovalsTable.vue?vue&type=script&lang=js"
export * from "./ApprovalsTable.vue?vue&type=script&lang=js"
import style0 from "./ApprovalsTable.vue?vue&type=style&index=0&id=11b4a6fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b4a6fe",
  null
  
)

export default component.exports